<template>
    <div class="custom-scroll h-100">

        <ul class="notification">
            <li class="unread">
                <div class="d-flex align-items-center show-child-on-hover">
                    <span class="d-flex flex-column flex-1">
                        <span class="name d-flex align-items-center">Administrator <span class="badge badge-success fw-n ml-1">UPDATE</span></span>
                        <span class="msg-a fs-sm">
                            System updated to version <strong>3.00</strong>
                            <i class="fal fa-deer"></i>
                            <i class="fal fa-deer"></i>
                            <i class="fal fa-deer"></i>
                            <i class="fal fa-deer"></i>
                        </span>
                        <span class="fs-nano text-muted mt-1">01.09.2020</span>
                    </span>
                    <div class="show-on-hover-parent position-absolute pos-right pos-bottom p-3">
                        <a href="#" class="text-muted" title="delete"><i class="fal fa-deer"></i></a>
                    </div>
                </div>


            </li>
        </ul>

        <div class="loader_calendar w-100 text-center pt-5 mt-5" v-if="!is_load">
          <sync-loader :loading="true" color="#7a59ad"  size="10px"></sync-loader>
        </div>
        <ul class="notification" v-else>
          <li class="unread" v-for="feed in this.feed_data">
              <div class="d-flex align-items-center show-child-on-hover">
                      <span class="d-flex flex-column flex-1">
                          <span class="name d-flex align-items-center">
                            {{feed.committer_name}}
                            <span class="badge badge-warning fw-n ml-1">{{feed.short_id}}</span>
                          </span>

                          <span class="msg-a fs-sm">
                              {{feed.title}}
                          </span>
                          <span class="fs-nano text-muted mt-1">
                            {{feed.created_at}}
                          </span>
                      </span>
              </div>
          </li>
        </ul>

    </div>
</template>

<script>
    import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

    export default {
        name: "feed",
        components : {
          SyncLoader,
        },

        created() {
          this.load_feed();
        },

        data() {
            return {
              is_load:false,
              _url : "/index.php?option=com_imc_docs&task=api.get_user_api",
              feed_data : [],
            }
        },
        methods : {
          async load_feed() {
            console.log("Feed");

            await axios.post("/index.php?option=com_imc_docs&task=api.getGitlabCommit").then(({data}) => {
              this.portal_api = true;
              if (data.status === "operation_success") {
                this.feed_data = data.message;
              } else {
                this.feed_data =[];
              }
            }).catch(err => {
              this.is_load = true;
              this.feed_data = [];
              //EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
              this.is_load = false;
            });
          },
        }



      }
</script>

<style scoped>

</style>
